import type { IconData } from '@stacksjs/iconify-core'

export const natureCat: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.5 9c0 .698.11 1.37.314 2H0v1.5h2.522q.177.278.382.535L1 14.94L2.06 16l1.905-1.904C5.073 14.975 6.475 15.5 8 15.5s2.927-.525 4.035-1.404L13.94 16L15 14.94l-1.904-1.905a7 7 0 0 0 .382-.535H16V11h-1.813a6.5 6.5 0 0 0 .313-2V.5A5 5 0 0 0 9.729 4H6.27A5 5 0 0 0 1.5.5zM8 13l-2-2h4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureCat
